import { calculateAmortizationCompound } from './common/calculateAmotizationCompound';
import { calculateAmortizationSimple } from './common/calculateAmotizationSimple';
import { calculateAmortizationSimpleFactoring } from './common/calculateAmotizationSimpleFactoring';

export const calculateAmortization = ({
  creditDetails,
  setAmortizationSchedule,
  workingDayActive,
  documents,
}: {
  creditDetails: any;
  setAmortizationSchedule: any;
  workingDayActive: 'active' | 'inactive';
  documents?: any;
}) => {
  if (creditDetails.interestType === 'SIMPLE') {
    calculateAmortizationSimple({
      creditDetails,
      setAmortizationSchedule,
      workingDayActive,
      documents,
    });
  } else if (creditDetails.interestType === 'SIMPLE_FACTORING') {
    calculateAmortizationSimpleFactoring({
      creditDetails,
      setAmortizationSchedule,
      workingDayActive,
      documents,
    });
  } else {
    calculateAmortizationCompound({
      creditDetails,
      setAmortizationSchedule,
      workingDayActive,
      documents,
    });
  }
};
